// extracted by mini-css-extract-plugin
export var avatarContainer = "_8j-0";
export var avatarTypingWave = "_8j-i";
export var gray = "_8j-f";
export var green = "_8j-c";
export var icon = "_8j-9";
export var image = "_8j-1";
export var lg = "_8j-6";
export var md = "_8j-5";
export var presenceDot = "_8j-b";
export var red = "_8j-d";
export var sm = "_8j-4";
export var status = "_8j-a";
export var typingDot = "_8j-h";
export var typingPill = "_8j-g";
export var xl = "_8j-7";
export var xs = "_8j-3";
export var xxl = "_8j-8";
export var xxs = "_8j-2";
export var yellow = "_8j-e";